import { QuestionAndAnswerModel } from '../viewmodels/questionAndAnswer.model';

/**
 * Keeps only the questions the user has clicked or changed themselves. This is what may be reported
 * to NexusAudit.UserQuestionIds: an untouched question can still hold an AI-suggested default, and
 * reporting it would record that suggestion as if a human had confirmed it.
 */
export function filterTouchedQuestions(
  questionsAndAnswers: Array<QuestionAndAnswerModel>,
  touchedQuestionIds: Set<number>
): Array<QuestionAndAnswerModel> {
  return (questionsAndAnswers ?? []).filter((qa) => touchedQuestionIds.has(qa.questionId));
}
